import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { CardHolderComponent } from '../../../card-holder/card-holder.component';
import { GameTableBaseComponent } from '../../components/table/game-table-base.component';

@Component({
    selector: 'app-dragon-tiger-table',
    standalone: true,
    imports: [CommonModule, CardHolderComponent],
    templateUrl: '../../components/table/game-table-template.html',
    styleUrl: './dragon-tiger-table.component.scss'
})
export class DragonTigerTableComponent extends GameTableBaseComponent {}
